/*
  This page is for Account activation
  Author: Surojit Basu
  Date: Jan 20, 2021
*/
import React,{useEffect,useState,useContext} from 'react';
import {  
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Alert,
  ProgressBar
} from 'react-bootstrap';

import {useParams} from 'react-router-dom';
import {MessageModal} from '../components';
import UserContext from './../contexts/UserContext';
import './login.css';
import Utils from './../Utils';
import _ from 'lodash';

const Activate = (props) => {

  const {goActivate, selectedPackage} = useContext(UserContext);
  const [init,setInit] = useState(false);
  const [loading,setLoading] = useState(false);
  const [message,setMessage] = useState(false);   
  const { code, buy } = useParams();  
  const [stopActivation, setStopActivation ]  = useState(false);
  useEffect(()=>{        
    if(!Utils.isLoggedIn()){
      setInit(false);
      if(!_.isEmpty(code)){
      
        if(buy==='1' && !selectedPackage()) {          
          setStopActivation(true);          
        }
        else{
          confirmActivate({code : code});
        }
        
        
        return;
      }      
    }    
      window.location.href = process.env.PUBLIC_URL + '/builder';
    
  },[]);

  const onSubmit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();    
  }

  const confirmActivate =(data) =>{
    setLoading(true);
    goActivate(data,(success,message) => {
      setLoading(false);      
      setMessage([success ? 'success' : 'error',message]);       
      if(success){
        window.setTimeout(function(){
          window.location.href=process.env.PUBLIC_URL + '/login';
        }, 5000);
      }
    });
  }

  return <Container className="h-100 d-flex justify-content-center align-items-center">
    <Card className="card-shadowed">
      <Card.Body>
        <Row>
          <Col><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} className="logo" /></Col>
        </Row>
        <Row>
          <Col className="header">                          
              We are happy to see you.
          </Col>
        </Row>
        {stopActivation && <Alert variant="danger" className="p-3">
        Please use same browser to activate your account and continue your purchase.
        </Alert> }
        {!stopActivation  && <>
          {message  && <MessageModal type={message[0]} message={message[1]} onHide={() => {setMessage(false);}} />}

          {loading && <Alert variant="light" className="p-3">
            <p className="loading-msg">Activation process</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>}
          
          {!loading && <>                    
          <Form className="mt-4 mb-4" onSubmit={onSubmit}>
            <Row>
              <Col>
                <Form.Control required className="input-text" type="code" placeholder="Activation code" name="code"  value={code}></Form.Control>
              </Col>
            </Row>                         
            <Row className="mt-4 mb-4">
              <Col className="text-right"><Button type="submit" className="p-0 clear"><img src={`${process.env.PUBLIC_URL}/images/go_button.png`} alt="Login" /></Button></Col>
            </Row>
            <Row>            
              <Col><a href={`${process.env.PUBLIC_URL}/login`}>Try logging in!</a></Col>
            </Row>
          </Form>    
        </>}
        
        </>}
      </Card.Body>
    </Card>  
  </Container>

}

export default Activate;